import React, { useEffect, useState } from 'react'
import firebase from '../config.js'

export default function Add (props) {
  useEffect(() => {}, [])
  const [valid, setValid] = useState(false)
  const [pass, setPass] = useState('sectumsembra')
  return (
    <div id='sign_forum'>
      <div
        style={{
          position: 'relative',
          width: '100%',
          height: '100%',
          textAlign: 'center',
          display: 'flex'
        }}
      >
        <div
          onClick={() => {
            props.cleanup()
          }}
          id='hire_close'
        >
          X
        </div>

        {valid ? (
          <Form />
        ) : (
          <>
            <form
              style={formStyle}
              onSubmit={e => {
                e.preventDefault()
                e.target.children[0].value == pass
                  ? setValid(true)
                  : (e.target.children[1].innerHTML = 'You shall not pass!')
              }}
            >
              <input type='text' placeholder='Password' />
              <div></div>
              <input type='submit' value='Enter' />
            </form>
          </>
        )}
      </div>
    </div>
  )
}

function Form () {
  const [done, setDone] = useState(false)
  function sub (e) {
    e.preventDefault()
    let proj = firebase
      .firestore()
      .collection('projects')
      .doc()
    let thump = e.target.children[0].files[0]
    let name = e.target.children[1].value
    let info = e.target.children[2].value
    let images = e.target.children[3].files
    let tags = e.target.children[4].value
    let prog = e.target.children[5]
    let sub = e.target.children[6]
    sub.classList.add('loading')
    var t1 = firebase
      .storage()
      .ref('thumpnails/' + proj.id + '/' + thump.name)
      .put(thump)
    t1.then(async t => {
      console.log(t)
      let thumpUrl = await t.ref.getDownloadURL(),
        imagesUrl = []
      await Object.keys(images).forEach(async (i, k) => {
        var m1 = firebase
          .storage()
          .ref('images/' + proj.id + '/' + images[i].name)
          .put(images[i])
        m1.then(async m => {
          m.ref.getDownloadURL().then(async a => {
            await imagesUrl.push(a)
            if (Object.keys(images).length == imagesUrl.length) {
              await firebase
                .firestore()
                .collection('projects')
                .doc(name)
                .set({
                  id:proj.id,
                  name,
                  info,
                  thump: thumpUrl,
                  images: [...imagesUrl],
                  tags
                })
                .then(() => {
                  setDone(true)
                  sub.classList.remove('loading')
                })
            }
          })
        }).catch(e => console.log(e))
        m1.on('state_changed', snapshot => {
          var percentage =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100
          prog.value = percentage
        })
      })
    }).catch(e => console.log(e))
    t1.on('state_changed', snapshot => {
      var percentage = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
      prog.value = percentage
    })
  }

  return (
    <>
      {!done ? (
        <form onSubmit={e => sub(e)} style={formStyle}>
          <input
            type='file'
            name='proj_image'
            placeholder='Thumpnail'
            required
          />
          <input
            type='text'
            name='proj_name'
            placeholder='Project Name'
            required
          />
          <input
            type='text'
            name='proj_details'
            placeholder='Project Info'
            required
          />
          <input
            type='file'
            name='proj_images'
            placeholder='Project images'
            multiple
            required
          />
          <input
            type='text'
            name='proj_tags'
            placeholder='Tags (e.g html,css,js)'
            required
          />
          <progress></progress>
          <input type='submit' value='Add' />
        </form>
      ) : (
        <div style={{ margin: 'auto' }}>
          <h1>جامد يفندم</h1>
        </div>
      )}
    </>
  )
}

let formStyle = { width: '65%', margin: 'auto' }
